export default __webpack_public_path__ + "static/media/crop-x.d140bd32.png";